import type { FC } from 'react';
import { ChevronUp } from 'lucide-react';

interface HideFiltersTabProps {
  onHide: () => void;
}

export const HideFiltersTab: FC<HideFiltersTabProps> = ({ onHide }) => (
  <div className="flex justify-center">
    <button
      type="button"
      data-testid="toggle:hide-filters"
      onClick={onHide}
      className="-mt-px flex items-center gap-2 rounded-b-lg border border-t-0 border-gray-200 bg-gray-50 px-3 py-1 shadow-sm hover:bg-gray-100"
    >
      <ChevronUp aria-hidden="true" className="size-5 text-gray-500" />
      <span className="text-xs font-medium text-gray-500">HIDE FILTERS</span>
    </button>
  </div>
);
